export default class Util {
    static hasNestedProperty(obj, key) {
        if (key.indexOf('.') > -1) {
            let props = key.split('.')

            for (let i = 0; i < props.length; i++) {
                let prop = props[i]

                if (!obj.hasOwnProperty(prop)) {
                    return false
                } else {
                    obj = obj[prop]
                }
            }

            return true
        } else {
            return obj.hasOwnProperty(key)
        }
    }

    /**
     * Get a nested property from an object.
     *
     * @param obj
     * @param key
     * @param defaultValue
     * @returns {Object|*|*}
     */
    static getNestedProperty = function (obj, key, defaultValue = null) {
        if (key.indexOf('.') > -1) {
            let props = key.split('.')

            for (let i = 0; i < props.length; i++) {
                let prop = props[i]

                if (!obj.hasOwnProperty(prop)) {
                    return defaultValue
                } else {
                    obj = obj[prop]
                }
            }

            return obj
        }

        if (obj.hasOwnProperty(key)) {
            return obj[key]
        }

        return defaultValue
    }
}
